"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicBaseUrlClient = void 0;
const CustomizedApiClient_1 = require("./CustomizedApiClient");
const ClientUtils_1 = require("../utils/ClientUtils");
const SSMFlagUtils_1 = require("../utils/SSMFlagUtils");
const commons_logs_1 = require("@deliverr/commons-logs");
class DynamicBaseUrlClient {
    constructor(config) {
        this.ebsApiClient = new CustomizedApiClient_1.CustomizedApiClient(Object.assign({}, config));
        this.lambdaApiClient = new CustomizedApiClient_1.CustomizedApiClient(Object.assign(Object.assign({}, config), { baseURL: config.baseURLV2 || (0, ClientUtils_1.getLambdaApiBaseUrl)() }));
        this.lambdaClientSkippingApiGateway = new CustomizedApiClient_1.CustomizedApiClient(Object.assign(Object.assign({}, config), { baseURL: config.baseURLV2 || (0, ClientUtils_1.getLambdaApiBaseUrlSkippingApiGateway)() }));
    }
    async isV2Seller(sellerId) {
        try {
            if (!sellerId) {
                sellerId = ClientUtils_1.DUMMY_SELLER_ID;
            }
            if (ClientUtils_1.EBS_SELLER_ID === sellerId) {
                return false;
            }
            if (ClientUtils_1.V2_SELLER_IDS.includes(sellerId)) {
                return true;
            }
            if ((0, SSMFlagUtils_1.isSSMConfigPresentForTargetAPI)()) {
                return (0, SSMFlagUtils_1.isSellerConfiguredAsV2InSSM)(sellerId);
            }
            return false;
        }
        catch (e) {
            commons_logs_1.log.warn("Error determining if seller is V2", { sellerId, error: e });
            return false;
        }
    }
    async getApiClient(sellerId, shouldSkipApiGateway) {
        try {
            if (!(await this.isV2Seller(sellerId))) {
                return this.ebsApiClient;
            }
            return shouldSkipApiGateway || (0, SSMFlagUtils_1.shouldForceFunctionUrlForService)()
                ? this.lambdaClientSkippingApiGateway
                : this.lambdaApiClient;
        }
        catch (e) {
            commons_logs_1.log.warn("Error determining API client", { sellerId, error: e });
            return this.ebsApiClient;
        }
    }
}
exports.DynamicBaseUrlClient = DynamicBaseUrlClient;
//# sourceMappingURL=DynamicBaseUrlClient.js.map